import _ from 'lodash'

// Creates a reducer managing pagination, given the entity type to handle,
// and a function telling how to extract the key from an action.
export default function paginate(entityAction, mapActionToKey) {
  function updatePagination(state = {
    isFetching: false,
    nextPageUrl: undefined,
    pageCount: 0,
    ids: [],
  }, action) {
    switch (action.type) {
      case entityAction.REQUEST:
        return {
          ...state,
          isFetching: true,
        }
      case entityAction.SUCCESS:
        // Do not update pagination state if the response does not contain .results
        // e.g. where we only paginate for some api calls
        if (action.response.result.results === undefined) {
          return {
            ...state,
            isFetching: false,
          }
        }
        return {
          ...state,
          isFetching: false,
          ids: _.union(state.ids, action.response.result.results),
          nextPageUrl: action.response.result.next,
          pageCount: state.pageCount + 1,
        }
      case entityAction.FAILURE:
        return {
          ...state,
          isFetching: false,
        }
      default:
        return state
    }
  }

  return function updatePaginationByKey(state = {}, action) {
    switch (action.type) {
      case entityAction.REQUEST:
      case entityAction.SUCCESS:
      case entityAction.FAILURE: {
        const key = mapActionToKey(action)
        return {
          ...state,
          [key]: updatePagination(state[key], action),
        }
      }
      default:
        return state
    }
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/pagination/paginate.js
 **/